import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: 'alquiler-de-carro-empresas',
		loadChildren: () => import('./pages/enterprise/enterprise.module').then(m => m.EnterpriseModule),
		pathMatch: 'prefix',
	},
	{
		path: 'como-funciona-renta-renault',
		loadChildren: () => import('./pages/how-it-works/how-it-works.module').then(m => m.HowItWorksModule),
		pathMatch: 'prefix',
	},
	{
		path: 'contato',
		loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule),
		pathMatch: 'prefix',
	},
	{
		path: 'asesoria',
		loadChildren: () => import('./pages/request-help/request-help.module').then(m => m.RequestModule),
		pathMatch: 'prefix',
	},
	{
		path: 'politicas-de-privacidad-de-proteccion-de-datos-personales',
		loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
		pathMatch: 'prefix',
	},
	{
		path: 'termos-de-uso-del-sitio',
		loadChildren: () => import('./pages/terms-of-use/terms-of-use.module').then(m => m.TermsOfUseModule),
		pathMatch: 'prefix',
	},
		{
		path: 'politica-de-cobranza',
		loadChildren: () => import('./pages/terms-of-collection/terms-of-collection.module').then(m => m.TermsOfCollectionModule),
		pathMatch: 'prefix',
	},
	{
		path: 'politica-de-cookies',
		loadChildren: () => import('./pages/cookies-policy/cookies-policy.module').then(m => m.CookiesPolicyModule),
		pathMatch: 'prefix',
	},
	{
		path: 'faq-renta-de-carros',
		loadChildren: () => import('./pages/doubts/doubts.module').then(m => m.DoubtsModule),
		pathMatch: 'prefix',
	},
	{
		path: 'para-empresas-formulario',
		loadChildren: () => import('./pages/form-enterprise/form-enterprise.module').then(m => m.FormEnterpriseModule),
		pathMatch: 'prefix',
	},
	{
		path: 'nossas-lojas',
		loadChildren: () => import('./pages/stores/stores.module').then(m => m.StoresModule),
		pathMatch: 'prefix',
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class InstitutionalRoutingModule {}
